import React from 'react';
import { GlobeIcon, LockIcon } from 'lucide-react';

/** Reassurance shown right under the checkout button. */
export function SecurePaymentNote({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`mx-auto flex w-full max-w-[420px] flex-col gap-2.5 rounded-[14px] border border-brand-cta/25 bg-brand-cta/[0.06] px-5 py-4 text-left ${className}`} data-id="element-207" data-mp="1c8zdfgm12osa">
      <p className="flex items-center gap-2.5 font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-208" data-mp="1m7ojmc4kaksp">
        <LockIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-209" data-mp="1q8i939xnk7np" />
        100% secure, encrypted checkout
      </p>
      <p className="flex items-center gap-2.5 font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-210" data-mp="1v0ifnl889yt9">
        <GlobeIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-211" data-mp="1zy1qeb5pvtgg" />
        Payment processed in your local currency
      </p>
    </div>;
}